import BackupResource from "./backup.resource";

const backupModule = angular
  .module("app.resources.backup", [])
  .service("Backup", BackupResource);

export default backupModule;



// WEBPACK FOOTER //
// ./src/resources/backup/backup.module.js